import Axios from 'axios'
import _ from 'lodash'
import { config } from '../util/config'

const publicToken =
  '1db64352335204ab7f18c2a3d37f1abb7f8d52ba5c32995ef1eeb10aced58ec96662c48f138bc48636bf741fcf4ebc49044347cc381b83341018b5811f72f28ddb7312a9398431f8f3f16785b0ce308bd3dd2d34c1c2ac369101a64cbb071b61b2115c30648188429b3c778d93b702407b72d9a2f409385c9b6d0fcf14f46c8e'

const axios = Axios.create({ baseURL: config.API_REST_ENDPOINT })

// Helper function to handle silent delays between retries
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

axios.interceptors.request.use(function (config) {
  if (!config.noauth) {
    const token = localStorage.getItem('authToken') || publicToken
    // Don't override the auth header if a request has set a specific one.
    if (_.isNil(config?.headers?.Authorization)) {
      config.headers.Authorization = token ? `Bearer ${token}` : ''
    }
  }
  return config
})

// Response interceptor to catch network drops silently
axios.interceptors.response.use(
  (response) => response, // Pass through all successful requests
  async (error) => {
    const originalConfig = error.config

    // Fallback if config is missing (e.g., extreme browser-level cancellation)
    if (!originalConfig) {
      return Promise.reject(error)
    }

    // Set default retry options if not explicitly provided on the specific request
    const maxRetries = originalConfig.maxRetries ?? 3
    const retryDelay = originalConfig.retryDelay ?? 1000

    // Identify system/network level drops (no response back from a server)
    const isNetworkError = !error.response && error.code !== 'ECONNABORTED'

    if (isNetworkError) {
      // Initialize or increment the retry counter on the request config
      originalConfig.currentRetryCount = originalConfig.currentRetryCount || 0

      if (originalConfig.currentRetryCount < maxRetries) {
        originalConfig.currentRetryCount += 1

        // Exponential backoff delay (e.g., 1s, then 2s, then 3s)
        const backoff = retryDelay * originalConfig.currentRetryCount
        await delay(backoff)

        // Eject and re-run the exact request with the same auth headers
        return axios(originalConfig)
      }
    }

    // If retries are exhausted or it's a real API error (404, 500, etc.), bubble it up to the UI
    return Promise.reject(error)
  },
)

export default axios
